import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Dialog, Paper, styled } from '@mui/material';
var StyledDialog = styled(Dialog)(function (_ref) {
  var theme = _ref.theme;
  var styles = {};
  return styles;
});
var StyledPaper = styled(Paper)(function (_ref2) {
  var theme = _ref2.theme,
      width = _ref2.width;

  var styles = _defineProperty({
    borderRadius: theme.typography.pxToRem(12),
    maxWidth: width ? theme.typography.pxToRem(width) : undefined
  }, theme.breakpoints.down('md'), {
    margin: "".concat(theme.spacing(4), " ").concat(theme.spacing(2)),
    width: "calc(100% - ".concat(theme.typography.pxToRem(32), ")")
  });

  return styles;
});
export { StyledDialog, StyledPaper };